var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6834 33.8167L30.5001 27.6833C32.9002 24.6907 34.0626 20.8922 33.7481 17.0688C33.4336 13.2455 31.6662 9.68796 28.8093 7.12773C25.9524 4.5675 22.2231 3.19918 18.3883 3.30411C14.5535 3.40904 10.9046 4.97926 8.19199 7.6919C5.47935 10.4045 3.90914 14.0534 3.8042 17.8882C3.69927 21.723 5.06759 25.4523 7.62783 28.3092C10.1881 31.1661 13.7456 32.9335 17.5689 33.248C21.3922 33.5625 25.1908 32.4002 28.1834 30L34.3168 36.1333C34.4717 36.2895 34.656 36.4135 34.8591 36.4981C35.0622 36.5828 35.2801 36.6263 35.5001 36.6263C35.7201 36.6263 35.9379 36.5828 36.141 36.4981C36.3441 36.4135 36.5285 36.2895 36.6834 36.1333C36.9838 35.8226 37.1517 35.4072 37.1517 34.975C37.1517 34.5428 36.9838 34.1274 36.6834 33.8167ZM18.8334 30C16.526 30 14.2703 29.3158 12.3518 28.0338C10.4332 26.7519 8.93785 24.9298 8.05482 22.798C7.1718 20.6662 6.94076 18.3204 7.39092 16.0573C7.84108 13.7942 8.95223 11.7154 10.5838 10.0837C12.2155 8.45214 14.2943 7.34099 16.5574 6.89083C18.8205 6.44067 21.1663 6.67171 23.2981 7.55473C25.4299 8.43775 27.2519 9.9331 28.5339 11.8517C29.8158 13.7702 30.5001 16.0259 30.5001 18.3333C30.5001 21.4275 29.2709 24.395 27.083 26.5829C24.8951 28.7708 21.9276 30 18.8334 30Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3550984de1e340ca607840c3856a32c0.svg";
export { ForwardRef as ReactComponent };